import { FC } from 'react';

interface IPrevIconProps {
  stroke?: string;
}

const PrevIcon: FC<IPrevIconProps> = (props) => {
  const { stroke } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none">
      <path
        d="M10.6667 5.99992H1.33337M1.33337 5.99992L6.00004 10.6666M1.33337 5.99992L6.00004 1.33325"
        stroke={stroke ?? '#344054'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PrevIcon;
